import React from 'react';

export const StatusBadge = ({ status }) => {
  const map = {
    new: 'bg-[hsl(var(--sb-gold))]/15 text-[hsl(var(--sb-gold))] border-[hsl(var(--sb-gold))]/30',
    accepted: 'bg-blue-500/15 text-blue-300 border-blue-500/30',
    preparing: 'bg-orange-500/15 text-orange-300 border-orange-500/30',
    ready: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
    out_for_delivery: 'bg-cyan-500/15 text-cyan-300 border-cyan-500/30',
    completed: 'bg-[hsl(var(--sb-green))]/15 text-[hsl(var(--sb-green))] border-[hsl(var(--sb-green))]/30',
    cancelled: 'bg-red-500/10 text-red-300 border-red-500/30',
    pending: 'bg-[hsl(var(--sb-gold))]/15 text-[hsl(var(--sb-gold))] border-[hsl(var(--sb-gold))]/30',
    confirmed: 'bg-[hsl(var(--sb-green))]/15 text-[hsl(var(--sb-green))] border-[hsl(var(--sb-green))]/30',
    seated: 'bg-blue-500/15 text-blue-300 border-blue-500/30',
    no_show: 'bg-red-500/10 text-red-300 border-red-500/30',
  };
  const cls = map[status] || 'bg-white/5 text-white/70 border-white/15';
  const label = (status || '').replace('_', ' ');
  return (
    <span className={`inline-flex items-center gap-1 text-[11px] uppercase tracking-wider font-semibold px-2 py-1 rounded-full border ${cls}`}>{label}</span>
  );
};
